module.exports = __webpack_public_path__ + "4c3d0e4386b9738349f2313e58e4e780.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/unleash_giants_2-872.jpg
// module id = 584
// module chunks = 0